






















import { Component, Prop, Vue } from "vue-property-decorator";
import * as types from "../types/types";
export interface ITrustMessages {
  title: string;
  description?: string;
  type: string;
  highlighting?: string;
}

@Component({})
export default class TrustMessage extends Vue {
  @Prop() private lineItems!: types.LineItem[];
  @Prop() private deliveryExpectation?: string;
  @Prop() private madeIn: string;
  @Prop() private deliveryHighlighting!: string;

  get currentLang(): string {
    return window.lng;
  }

  get productType(): string {
    return this.lineItems[0].print.type;
  }

  get trustMessages(): ITrustMessages[] {
    if (this.lineItems.length === 0) {
      return [];
    }
    const messages: ITrustMessages[] = [];

    messages.push({
      title: this.$t("moneyBack.title"),
      type: "astro",
      description: this.$t("moneyBack.long"),
      highlighting: "GOOD",
    });

    if (this.deliveryExpectation) {
      messages.push({
        title: this.deliveryExpectation,
        type: this.productType === "digital" ? "digital" : "delivery",
        highlighting: undefined,
      });
    }
    if (this.madeIn) {
      messages.push({
        title: this.madeIn,
        type: this.madeIn.split(" ").pop().toLowerCase(),
      });
    }
    if (
      messages.length < 3 &&
      this.lineItems.some((l) => l.product.type === types.ProductType.starmap)
    ) {
      messages.push({
        title: this.$t("starmap:astoronomicallyAccurate"),
        type: "astro",
      });
    }

    return messages;
  }
}
